<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" @click.self="$emit('close')">
    <div class="bg-white rounded-lg shadow-xl border border-gray-200 p-6 w-full max-w-md">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-xl font-bold text-gray-800">Edit Player Position</h3>
        <button @click="$emit('close')" class="text-gray-400 hover:text-gray-700 text-lg transition-colors">
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <div class="mb-4">
        <span class="bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-full px-3 py-1 font-semibold text-xs shadow-sm">
          {{ player?.player?.player_name || player?.player_name }}
        </span>
      </div>

      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Position
        </label>

        <input
          v-model="selectedPosition"
          type="text"
          placeholder="Or enter custom position"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          maxlength="50"
        />
        <p class="text-xs text-gray-500 mt-1">Current: {{ currentPosition || 'Not set' }}</p>
      </div>

      <div class="flex gap-3 justify-end">
        <button
          @click="$emit('close')"
          class="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-semibold text-sm transition-colors"
        >
          Cancel
        </button>
        <button
          @click="savePosition"
          :disabled="saving"
          class="px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-lg font-semibold text-sm shadow-sm transition-all hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="saving">Saving...</span>
          <span v-else>Save Position</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

const props = defineProps({
  player: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['close', 'update:player'])

const commonPositions = ['PG', 'SG', 'SF', 'PF', 'C', 'G', 'F', 'C-F', 'F-C', 'G-F']
const selectedPosition = ref('')
const currentPosition = ref('')
const saving = ref(false)

onMounted(() => {
  // Get current position from player object
  currentPosition.value = props.player?.player?.position || ''
  selectedPosition.value = currentPosition.value
})

async function savePosition() {
  if (saving.value) return
  
  saving.value = true
  
  try {
    const response = await axios.put(`/api/players/${props.player.player.id}/position`, {
      position: selectedPosition.value || null
    })

    if (response.data.success) {
      // Update the player object
      const updatedPlayer = { ...props.player }
      if (updatedPlayer.player) {
        updatedPlayer.player.position = selectedPosition.value || null
      }
      emit('update:player', updatedPlayer)
      emit('close')
    }
  } catch (error) {
    console.error('Error updating player position:', error)
    alert('Failed to update player position. Please try again.')
  } finally {
    saving.value = false
  }
}
</script>

<style scoped>
</style>
